"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fs_extra_1 = require("fs-extra");
var webpack_merge_1 = require("webpack-merge");
var logger_1 = __importDefault(require("../helpers/logger"));
var appPaths = __importStar(require("./app-paths"));
var non_webpack_require_1 = __importDefault(require("../helpers/non-webpack-require"));
var chalk_1 = __importDefault(require("chalk"));
var config_validator_1 = require("../types/config.validator");
var error = logger_1.default('ERROR:', chalk_1.default.red);
var getTauriConfig = function (cfg) {
    var _a, _b, _c;
    var pkgPath = appPaths.resolve.app('package.json');
    var tauriConfPath = appPaths.resolve.tauri('tauri.conf.json');
    if (!fs_extra_1.existsSync(tauriConfPath)) {
        error("Could not find a tauri config (tauri.conf.json) in your app's directory.");
        process.exit(1);
    }
    var tauriConf = JSON.parse(fs_extra_1.readFileSync(tauriConfPath).toString());
    var pkg = fs_extra_1.existsSync(pkgPath)
        ? non_webpack_require_1.default(pkgPath)
        : null;
    var config = webpack_merge_1.merge({
        build: {},
        ctx: {},
        tauri: {
            embeddedServer: {
                active: true
            },
            bundle: {
                active: true,
                icon: [],
                resources: [],
                externalBin: [],
                deb: {
                    depends: []
                },
                osx: {
                    frameworks: []
                }
            },
            allowlist: {
                all: false
            },
            window: {
                title: (_a = pkg === null || pkg === void 0 ? void 0 : pkg.productName) !== null && _a !== void 0 ? _a : 'Tauri App'
            },
            security: {
                csp: "default-src blob: data: filesystem: ws: http: https: 'unsafe-eval' 'unsafe-inline'"
            },
            inliner: {
                active: true
            }
        }
    }, tauriConf, cfg);
    if (!config_validator_1.isTauriConfig(config)) {
        var messages = config_validator_1.ajv
            .errorsText((_b = config_validator_1.isTauriConfig.errors) === null || _b === void 0 ? void 0 : _b.filter(function (e) { return e.keyword !== 'if'; }).map(function (e) {
            e.dataPath = e.dataPath.replace(/\./g, ' > ');
            if (e.keyword === 'additionalProperties' &&
                typeof e.message === 'string' &&
                'additionalProperty' in e.params) {
                e.message = "has unknown property " + e.params.additionalProperty;
            }
            return e;
        }), { dataVar: 'tauri.conf.json', separator: '\n' })
            .split('\n');
        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
            var message = messages_1[_i];
            error(message);
        }
        process.exit(1);
    }
    var runningDevServer = (_c = config.build.devPath) === null || _c === void 0 ? void 0 : _c.startsWith('http');
    if (!runningDevServer) {
        config.build.devPath = appPaths.resolve.tauri(config.build.devPath);
        process.env.TAURI_DIST_DIR = config.build.devPath;
    }
    if (config.build.distDir) {
        config.build.distDir = appPaths.resolve.tauri(config.build.distDir);
        process.env.TAURI_DIST_DIR = config.build.distDir;
    }
    // OSX bundle config
    if (config.tauri.bundle.osx) {
        var license = config.tauri.bundle.osx.license;
        if (typeof license === 'string') {
            config.tauri.bundle.osx.license = appPaths.resolve.tauri(license);
        }
        else if (license !== null) {
            var licensePath = appPaths.resolve.app('LICENSE');
            if (fs_extra_1.existsSync(licensePath)) {
                config.tauri.bundle.osx.license = licensePath;
            }
        }
    }
    // bundle targets
    if (Array.isArray(config.tauri.bundle.targets)) {
        if (process.platform !== 'win32') {
            config.tauri.bundle.targets = config.tauri.bundle.targets.filter(function (t) { return t !== 'msi'; });
        }
    }
    process.env.TAURI_DIR = appPaths.tauriDir;
    process.env.TAURI_CONFIG = JSON.stringify(config);
    return config;
};
exports.default = getTauriConfig;
